/** @format — Live streamed plain text (chunks append; no typewriter animation) */

import React, { memo } from "react";

function StreamingAgentText({ text }) {
  if (!text) return null;

  return (
    <div
      className="text-[#1D2739] text-[14px] lg:text-[15px] leading-relaxed whitespace-pre-wrap break-words"
      style={{ overflowWrap: "anywhere" }}
    >
      {text}
    </div>
  );
}

export default memo(StreamingAgentText);
